import { render, staticRenderFns } from "./SubmitBtn.vue?vue&type=template&id=7a0b5298"
import script from "./SubmitBtn.vue?vue&type=script&lang=ts"
export * from "./SubmitBtn.vue?vue&type=script&lang=ts"
import style0 from "./SubmitBtn.vue?vue&type=style&index=0&id=7a0b5298&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports